// santa form

jQuery(document).ready(function($) {
	// watch for select change
	function selectChange() {
		var $selectMaster = $('.santa-form select').eq(0);
		$($selectMaster).on('change', function() {
			var $el = $(this);
			var index = $el[0].selectedIndex;
			var $select1 = $('.santa-form select').eq(1);
			var $select2 = $('.santa-form select').eq(2);
			if (index == 0) {
				$select1.hide();
				validateFalse($select1);
				$select2.hide();
				validateFalse($select2);
			}
			if (index == 1) {
				$select2.hide();
				validateFalse($select2);
				$select1.show();
				validateTrue($select1);
			}
			if (index == 2) {
				$select1.hide();
				validateFalse($select1);
				$select2.show();
				validateTrue($select2);
			}
		});
	}

	// validation on
	function validateTrue(el) {
		$(el)
			.attr('required', true)
			.attr('aria-required', true)
			.attr('aria-invalid', false);
		el[0].selectedIndex = 0;
	}

	// validation off
	function validateFalse(el) {
		el[0].selectedIndex = -1;
		$(el)
			.attr('required', false)
			.attr('aria-required', false)
			.attr('aria-invalid', false);
		$(el)
			.closest('.form-group')
			.removeClass('has-error');
	}

	// init
	if ($('.santa-form').length) {
		$('.santa-form select')
			.eq(1)
			.hide();
		$('.santa-form select')
			.eq(2)
			.hide();
		selectChange();
	}
});
